module.exports = __webpack_public_path__ + "static/media/phenvelope-fill.40901db1.svg";